import { createGlobalStyle } from "styled-components";

const globalStyle = createGlobalStyle`
  body {
    font-family: Inter, system-ui, sans-serif;
    background-color: ${({ theme }) => theme.colors.bg} !important;

    color: ${({ theme }) => theme.colors.text} !important;
  }
  h1, h2, h3, h4, h5, h6 { font-family: Inter, system-ui, sans-serif; }

  p, .p{
    color: ${({ theme }) => theme.colors.text};
    font-size: 18px;
    font-weight: 300;
    letter-spacing: -0.56px;
    line-height: 30px;
    margin-bottom: 0;
  }

  ul,.ul{
    list-style: none;
    margin: 0;
    padding: 0;
  }


  a {
    color: ${({ theme }) => theme.colors.text};
    transition: color 0.2s ease-out, background-color 0.2s ease-out;
    &:hover, &:active, &:focus{
      color: ${({ theme }) => theme.colors.secondary};
      text-decoration: none;
    }
    &:focus-visible { outline: 2px solid currentColor; outline-offset: 4px; }
  }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      /* display: none; <- Crashes Chrome on hover */
      -webkit-appearance: none;
      margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    input[type="number"] {
      -moz-appearance: textfield; /* Firefox */
    }
`;

export default globalStyle;
